/**
 * Products an agent may pick for a sale, given the selected carrier's products.
 *
 * The product dropdowns on the New Sale page and on the lead page's Edit Sale
 * modal both read `carrier.products`, which the server sends unfiltered (the
 * PoliciesCarrierResource re-queries every product of the agency carrier). The
 * New Sale page hid `is_active = 0` rows client-side; the Edit Sale modal did
 * not, so an agent editing a sale saw every retired product of the carrier and
 * could move the sale onto one. This is the single place the rule lives now.
 *
 * `keepProductId` is the product the sale was written on. It stays selectable
 * even when it has since been deactivated, so the modal still displays the
 * sale's own product and saving without touching it does not fail validation.
 *
 * @param {Array<{id: number, is_active: (number|boolean)}>|undefined|null} products
 * @param {number|null} [keepProductId]
 * @returns {Array|undefined} undefined when no carrier is selected yet
 */
export function selectableSaleProducts(products, keepProductId = null) {
    if (!Array.isArray(products)) {
        return undefined;
    }

    return products.filter((product) => Boolean(product.is_active) || (keepProductId !== null && product.id === keepProductId));
}
